(function () {
  function createErrorOverlay() {
    // Create overlay with inline styles (since vanilla-extract CSS classes aren't available yet)
    const overlay = document.createElement("div");
    overlay.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.33);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Roobert, sans-serif;
        `;

    // Create content box
    const contentBox = document.createElement("div");
    contentBox.style.cssText = `
          background: #FFFFFF;
          padding: 32px;
          border-radius: 24px;
          text-align: center;
          max-width: 450px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
        `;

    // Create title
    const title = document.createElement("h3");
    title.style.cssText = `
          color: #2A2929;
          margin-top: 0;
          margin-bottom: 16px;
          font: normal 500 1.75rem /2.25rem Roobert, sans-serif;
        `;
    title.textContent = "Aktualisierung verfügbar";

    // Create message
    const message = document.createElement("p");
    message.style.cssText = `
          color: #666666;
          margin: 0 0 32px 0;
          line-height: 1.625;
          font: normal 400 1.125rem /1.625 Roobert, sans-serif;
        `;
    message.textContent =
      "Es gab Aktualisierungen auf der Seite, bitte lade die Seite neu.";

    // Create reload button
    const reloadBtn = document.createElement("button");
    reloadBtn.style.cssText = `
          background: #A951ED;
          color: #FFFFFF;
          border: none;
          padding: 12px 16px;
          border-radius: 12px;
          cursor: pointer;
          font: normal 400 1.125rem /1.625rem Roobert, sans-serif;
          width: 100%;
          transition: background-color 0.2s ease;
        `;
    reloadBtn.textContent = "Seite neu laden";

    reloadBtn.onclick = () => window.location.reload();

    // Assemble the overlay
    contentBox.appendChild(title);
    contentBox.appendChild(message);
    contentBox.appendChild(reloadBtn);
    overlay.appendChild(contentBox);

    return overlay;
  }

  // Handle Vite preload errors
  window.addEventListener("vite:preloadError", (event) => {
    const overlay = createErrorOverlay();
    document.body.appendChild(overlay);
  });
})();
